// extracted by mini-css-extract-plugin
export var Header = "Header-module--Header--6d488";